<ng-template>
  <div (click)="autoClose ? closed.emit(): false">
    <!-- <div class="custDropdown-content"> -->
    <ng-content></ng-content>
  </div>
</ng-template>
